import * as Yup from 'yup';

// Reference: https://git.iwoca.co.uk/iwoca/iwoca-django/-/blob/master/lending_decision/sign_up/utils.py#L44
const POSTCODE_REGEX =
  /^[a-zA-Z]{1,2}([0-9]{1,2}|[0-9][a-zA-Z])\s*[0-9][a-zA-Z]{2}$/;

export const addressValidator = Yup.object().shape({
  manual: Yup.boolean(),
  buildingNumber: Yup.string().when('manual', {
    is: true,
    then: (schema) => schema.required('Building number is required'),
    otherwise: (schema) => schema,
  }),
  streetName: Yup.string().when('manual', {
    is: true,
    then: (schema) => schema.required('Street name is required'),
    otherwise: (schema) => schema,
  }),
  town: Yup.string().when('manual', {
    is: true,
    then: (schema) => schema.required('Town is required'),
    otherwise: (schema) => schema,
  }),
  postcode: Yup.string()
    .required('Post code is required')
    .test('is-postcode', 'Not a valid postcode', (postcode) =>
      POSTCODE_REGEX.test(postcode),
    ),
});
